import DOMPurify from 'dompurify'

/**
 * マークダウンのボールドテキスト(**text**)をHTMLのstrongタグに変換し、
 * XSS攻撃を防ぐためにサニタイズする
 * @param text サニタイズする文字列
 * @returns サニタイズされたHTML文字列
 */
export const sanitizeAndHighlight = (text: string): string => {
  // マークダウンのボールド記法をHTMLに変換
  const highlighted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
  // DOMPurifyでサニタイズ（strongタグのみ許可）
  return DOMPurify.sanitize(highlighted, {
    ALLOWED_TAGS: ['strong'],
    ALLOWED_ATTR: [],
  })
}

/**
 * 一般的な入力値のサニタイゼーション
 * XSS攻撃を防ぐために、HTMLタグやスクリプトを除去
 * @param input サニタイズする入力値
 * @returns サニタイズされた文字列
 */
export const sanitizeInput = (input: string): string => {
  // DOMPurifyを使用してHTMLタグを完全に除去
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [], // すべてのHTMLタグを除去
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true, // テキストコンテンツは保持
  })
}
